module.exports = __webpack_public_path__ + "static/media/bicycle.e1724454.jpg";